<template>
  <div>
    <div v-for="user in users" :key="user.user">
      {{ user.user }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            icon
            text
            color="primary"
            v-on="on"
            @click="revokePrivileges(user)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Revoke Privileges</span>
      </v-tooltip>
    </div>
    <template v-if="selectedDatabase">
<!--      <user-privileges-modal-->
<!--        :opened="privilegesModalOpened"-->
<!--        :user="selectedUser"-->
<!--        :database="selectedDatabase"-->
<!--        @action-completed="$emit('action-completed')"-->
<!--        @close="closePrivilegesModal"-->
<!--      />-->
      <revoke-user-modal
        :opened="revokeModalOpened"
        :user="selectedUser.user"
        :database="selectedDatabase.db"
        @action-completed="$emit('action-completed')"
        @close="closeRevokeModal"
      />
    </template>
  </div>
</template>

<script>
// import UserPrivilegesModal from './UserPrivilegesModal'
import RevokeUserModal from './RevokeUserModal'

export default {
  name: 'PrivilegedUsersCell',
  components: {
    // UserPrivilegesModal,
    RevokeUserModal,
  },
  props: {
    users: {
      type: Array,
      required: true,
    }
  },
  data () {
    return {
      active: false,
      selectedUser: null,
      selectedDatabase: null,
      privilegesModal: false,
      revokeModal: false,
    }
  },
  computed: {
    privilegesModalOpened () {
      return !!this.selectedUser && !!this.selectedDatabase && this.privilegesModal
    },
    revokeModalOpened () {
      return !!this.selectedUser && !!this.selectedDatabase && this.revokeModal
    },
  },
  methods: {
    managePrivileges (user) {
      this.selectedUser = { ...user }
      this.selectedDatabase = { db: user.db }
      this.privilegesModal = true
    },
    closePrivilegesModal () {
      this.selectedUser = null
      this.selectedDatabase = null
      this.privilegesModal = false
    },
    revokePrivileges (user) {
      this.selectedUser = { ...user }
      this.selectedDatabase = { db: user.db }
      this.revokeModal = true
    },
    closeRevokeModal () {
      this.selectedUser = null
      this.selectedDatabase = null
      this.revokeModal = false
    },
  },
}
</script>
